import { S1BacProcess } from "./bac-process";
import { S1ProcessID } from "./s1-processid";

export class BacProcessSaveRequest {
    processID: S1ProcessID;
    processIn: S1BacProcess;
}